<template>
    <div>
        <md-sidenav class="md-right worknote-side-nav" ref="worknoteSidenav" @open="open()" @close="close()">
            <md-toolbar class="worknote-side-nav-toolbar main-toolbar">
                <div class="worknote-side-nav-toolbar-labels">
                    <p v-if="isSwitchedArchive">Work Note Archive</p>
                    <p v-else>Current Work Notes</p>
                    <span v-if="isSwitchedArchive">Found: {{getUnArchivedNotesCount}}</span>
                    <span v-else>Found: {{getCurrentWorkNotes.length}}</span>
                </div>
                <md-button class="btn-close-worknote-sidenav md-icon-button md-fab md-clean md-mini" @click="closeWorkNoteNav"><md-icon>close</md-icon></md-button>
            </md-toolbar>
            <md-list class="worknote-side-nav-items-list">
                <div class="switch-mode-link">
                    <md-button class="md-raised" @click="exportList">Export</md-button>
                    <div v-if="isSwitchedArchive" @click="changeViewMode">
                        <md-icon>unarchive</md-icon>
                        <span>View Current Work Notes</span>
                    </div>
                    <div v-else @click="changeViewMode">
                        <md-icon>move_to_inbox</md-icon>
                        <span>View Work Note Archive</span>
                    </div>
                </div>
                <div class="list-view-visible-layers">
                    <strong style="margin-right: 1rem;">Visible Layers:</strong>
                    <md-checkbox
                        v-for="layer in layers"
                        :key="layer.id"
                        :value="visibleListLayerIDs.includes(layer.id)"
                        @change="val => changeVisibleListLayer(layer.id, val)"
                        style="margin-right: 1rem;"
                    >
                        {{ layer.title }}
                    </md-checkbox>
                </div>
                    <div v-if="!isSwitchedArchive">
                        <div v-for="(item, index) in groupedByUnArchivedPages" :key="item.data.editedAt+''+index">
                            <md-list-item 
                                :disabled="item.type === 'page'" 
                                v-if="item.type === 'page' && getCurrentWorkNotes.length > 0" 
                                class="worknote-item-page" 
                            >
                                Page {{project.pdfPageNumbers && project.pdfPageNumbers[item.data.pageNumber - 1] && 
                                    project.pdfPageNumbers[item.data.pageNumber - 1].name && project.pdfPageNumbers[item.data.pageNumber - 1].name}}
                            </md-list-item>
                            <md-list-item 
                                v-if="item.type === 'layer' && visibleListLayerIDs.includes(item.data.layer)" 
                                class="worknote-item-layer"
                                style="border-bottom:0"
                            >
                                {{splicePageNumber(item.data)}}
                            </md-list-item>
                            <div v-if="visibleListLayerIDs.includes(item.data.layer)">
                               
                                <md-list-item 
                                    v-if="item.type === 'cue' && !item.data.archived" 
                                    class="worknote-item-cue" 
                                    @click="gotoCue(item.data)" 
                                    :class="{'selectedCue': item.data.id === focusedCueId}" 
                                    :key="item.data.id"
                                >
                                    <md-icon v-show="item.data.id === focusedCueId">arrow_right</md-icon>
                                    <div class="worknote-item-cue-info" >
                                        <div class="worknote-item-cue-info-body" >
                                            <span class="worknote-item-cue-info-desc" >{{item.data.workNote}}</span>
                                            <span class="worknote-item-cue-info-date" style="padding-top:0">
                                                {{getEditedDateTime(item.data)}}
                                                <md-button class="md-icon-button btn-archive-cue" v-if="editable(item.data) && !isSwitchedArchive" @click="archiveWorkNoteCue(item.data, $event)">
                                                    <md-icon>move_to_inbox</md-icon>
                                                    <md-tooltip md-direction="top">Archive note</md-tooltip>
                                                </md-button>
                                            
                                            </span>
                                        </div> 
                                    </div>
                                </md-list-item>
                            </div>
                        </div>    
                    </div>

                    <div v-if="isSwitchedArchive">
                        <div v-for="(item, index) in groupedByArchivedPages" :key="item.data.editedAt+''+index">
                            <md-list-item 
                                :disabled="item.type === 'page'" 
                                v-if="item.type === 'page'  && getUnArchivedNotesCount > 0" 
                                class="worknote-item-page" 
                            >
                                Page {{project.pdfPageNumbers && project.pdfPageNumbers[item.data.pageNumber - 1] && 
                                    project.pdfPageNumbers[item.data.pageNumber - 1].name && project.pdfPageNumbers[item.data.pageNumber - 1].name}}
                            </md-list-item>
                            <md-list-item 
                                v-if="item.type === 'layer' && visibleListLayerIDs.includes(item.data.layer)" 
                                class="worknote-item-layer" 
                                style="border-bottom:0"
                            >
                                {{splicePageNumber(item.data)}}
                            </md-list-item>
                            <md-list-item 
                                v-if="item.type === 'cue' && item.data.archived && visibleListLayerIDs.includes(item.data.layer)" 
                                class="worknote-item-cue" 
                                @click="gotoCue(item.data)" 
                                :class="{'selectedCue': item.data .editedAt === focusedCueEditedAt}" 
                                :key="item.data.editedAt"
                            >
                                <md-icon v-show="item.data.editedAt === focusedCueEditedAt">arrow_right</md-icon>
                                <div class="worknote-item-cue-info">
                                    <div class="worknote-item-cue-info-body">
                                        <span class="worknote-item-cue-info-desc" >{{item.data.workNote}}</span>
                                        <span class="worknote-item-cue-info-date" style="padding-top:0'">
                                            {{getEditedDateTime(item.data)}}
                                            <md-button class="md-icon-button btn-archive-cue" v-if="editable(item.data)" @click="unArchiveWorkNoteCue(item, $event)">
                                                <md-icon>unarchive</md-icon>
                                                <md-tooltip md-direction="left">Restore as the current note. Any current note on this cue is archived, not deleted.</md-tooltip>
                                            </md-button>
                                            <md-button class="md-icon-button btn-archive-cue" v-if="editable(item.data)" @click="removeArchivedNote(item, $event)">
                                                <md-icon>delete</md-icon>
                                                <md-tooltip md-direction="left">Permanently delete this note.</md-tooltip>
                                            </md-button>
                                        </span>
                                    </div>
                                </div>
                                
                            </md-list-item>
                        </div>    
                    </div>
                    
                
                
            </md-list>
        </md-sidenav>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Utils from '@/lib/Utils';
import { archiveNote, restoreNote, removeNote, openNoteText, workNotesCsv } from '@/lib/worknotes';
import NavBus from '@/buses/nav';
/**
 * WorkNoteCuesNav
 */
const WorkNoteCuesNav = {
    name: 'WorkNoteCuesNav',
    props: [],
    data: function() {
        return {
            focusedCueId: null,
            focusedCueEditedAt: null,
            isSwitchedArchive: false,
            cueAttributes: Utils.cueAttributes,
            sortBy: 'page',
            sortAsc: true,
            attributes: {...Utils.cueAttributes, parts_id: 'P', parts_label: 'Label'}
        };
    },
    computed: {
        ...mapGetters([
            'worknoteCues',
            'layerByCue',
            'allVisibleListCues',
            'editableLayers',
            'visibleListLayers',
            'layers',
            'visibleListLayerIDs',
            'project',
            'notes'
        ]),
        getCurrentWorkNotes() {
            const currentWorkNotes = this.groupedByUnArchivedPages.filter(item => item.type === 'cue' && this.visibleListLayerIDs.includes(item.data.layer));
            return currentWorkNotes;
        },
        groupedByPages() {
            if (this.worknoteCues.length === 0) return [];
            let prevPage = 0;
            return this.worknoteCues.sort((a, b) => a.pageNumber - b.pageNumber).reduce((grouped, cue) => {
                if (cue.pageNumber !== prevPage) {
                    prevPage = cue.pageNumber;
                    grouped.push({type: 'page', data: { id: cue.pageNumber, pageNumber: cue.pageNumber }});
                }
                grouped.push({
                    type: 'cue',
                    data: {
                        id: cue.id,
                        title: cue.title,
                        workNote: cue.data.workNote,
                        layer: cue.layer,
                        layerTitle: (this.layerByCue(cue) || {}).title || '',
                        pageNumber: cue.pageNumber,
                        editedAt: cue.editedAt || '',
                        archived: cue.archived || false
                    }
                });
                return grouped;
            }, []);
        },
        getUnArchivedNotesCount() {
            const unUnarchivedArr = this.groupedByArchivedPages;
            const workNotes = unUnarchivedArr.filter(item => item.type === 'cue' && this.visibleListLayerIDs.includes(item.data.layer));
            return Math.max(0, workNotes.length);
        },
        groupedByArchivedPages() {
            if (this.worknoteCues.length === 0) return [];
            let prevPage = 0;
            let prevLayerTitle = '';
            return this.worknoteCues.map(cue => ({...cue, layerTitle: (this.layerByCue(cue) || {}).title || ''}))
            .sort((a, b) => {
                if (a.layerTitle < b.layerTitle) return -1;
                if (a.layerTitle > b.layerTitle) return 1;
                return 0;
            }).sort((a, b) => a.pageNumber - b.pageNumber).filter(cue => cue.data.workNote)
            .reduce((grouped, cue) => {
                if (typeof cue.data.workNote === 'string') {
                    return grouped;
                }
                const workNotes = cue.data.workNote.filter(notes => notes.archived);

                if (workNotes.length < 1) return grouped;
                if (cue.pageNumber !== prevPage) {
                    prevPage = cue.pageNumber;
                    grouped.push({type: 'page', data: { id: cue.pageNumber, pageNumber: cue.pageNumber, layer: cue.layer }});
                }
                const layerTitle = (this.layerByCue(cue) || {}).title || '';
                const mixTitle = cue.pageNumber + layerTitle + ' ' + cue.title;
                if (mixTitle !== prevLayerTitle) {
                    prevLayerTitle = mixTitle;
                    grouped.push({type: 'layer', data: { id: cue.pageNumber, title: mixTitle, layer: cue.layer }});
                }

                cue.data.workNote.map((note) => {
                    if (note.archived) {
                        grouped.push({
                            type: 'cue',
                            data: {
                                id: cue.id,
                                title: cue.title,
                                workNote: note.note,
                                archived: note.archived,
                                editedAt: note.editedAt,
                                layer: cue.layer,
                                layerTitle: (this.layerByCue(cue) || {}).title || '',
                                pageNumber: cue.pageNumber,
                                data: cue.data
                            }
                        });
                    }
                    return note;
                });

                return grouped;
            }, []);
        },
        groupedByUnArchivedPages() {
            if (this.worknoteCues.length === 0) return [];
            let prevPage = 0;
            let prevLayerTitle = '';
            return this.worknoteCues.map(cue => ({...cue, mixTitle: cue.pageNumber + (this.layerByCue(cue) || {}).title + ' ' + cue.title || cue.pageNumber + ' ' + cue.title }))
            .sort((a, b) => {
                if (a.mixTitle < b.mixTitle) return -1;
                if (a.mixTitle > b.mixTitle) return 1;
                return 0;
            }).sort((a, b) => a.pageNumber - b.pageNumber).filter(cue => cue.data.workNote)
            .reduce((grouped, cue) => {
                if (typeof cue.data.workNote === 'string') {
                    if (cue.data.workNote) {
                        if (cue.pageNumber !== prevPage) {
                            prevPage = cue.pageNumber;
                            grouped.push({type: 'page', data: { id: cue.pageNumber, pageNumber: cue.pageNumber, layer: cue.layer }});
                        }
                        const layerTitle = (this.layerByCue(cue) || {}).title || '';
                        const mixTitle = cue.pageNumber + layerTitle + ' ' + cue.title;
                        if (mixTitle !== prevLayerTitle) {
                            prevLayerTitle = mixTitle;
                            grouped.push({type: 'layer', data: { id: cue.pageNumber, title: mixTitle, layer: cue.layer }});
                        }
                        grouped.push({
                            type: 'cue',
                            data: {
                                id: cue.id,
                                title: cue.title,
                                workNote: cue.data.workNote,
                                archived: false,
                                editedAt: cue.editedAt || Date.now(),
                                layer: cue.layer,
                                layerTitle: (this.layerByCue(cue) || {}).title || '',
                                pageNumber: cue.pageNumber,
                                data: cue.data
                            }
                        });
                    }
                } else {
                    const workNotes = cue.data.workNote.filter(notes => !notes.archived);

                    if (workNotes.length < 1) return grouped;
                    
                    if (cue.pageNumber !== prevPage) {
                        prevPage = cue.pageNumber;
                        grouped.push({type: 'page', data: { id: cue.pageNumber, pageNumber: cue.pageNumber, layer: cue.layer }});
                    }
                    
                    const layerTitle = (this.layerByCue(cue) || {}).title || '';
                    const mixTitle = cue.pageNumber + layerTitle + ' ' + cue.title;
                    if (mixTitle !== prevLayerTitle) {
                        prevLayerTitle = mixTitle;
                        grouped.push({type: 'layer', data: { id: cue.pageNumber, title: mixTitle, layer: cue.layer }});
                    }

                    cue.data.workNote.map((note) => {
                        if (!note.archived) {
                            grouped.push({
                                type: 'cue',
                                data: {
                                    id: cue.id,
                                    title: cue.title,
                                    workNote: note.note,
                                    archived: note.archived,
                                    editedAt: note.editedAt,
                                    layer: cue.layer,
                                    layerTitle: (this.layerByCue(cue) || {}).title || '',
                                    pageNumber: cue.pageNumber,
                                    data: cue.data
                                }
                            });
                        }
                        return note;
                    });
                }

                return grouped;
            }, []);
        },
        allCues: function() {
            return this.allVisibleListCues.filter(c => this.visibleListLayers.some(l => l.id === c.layer)).map(c => ({...c, title: c.title.trim(), layer: this.layerByCue(c)})).sort((a, b) => {
                if (this.sortBy) {
                    if (this.sortBy === 'page') {
                        if (this.sortAsc) {
                            if (a.pageNumber > b.pageNumber) return 1;
                            if (a.pageNumber < b.pageNumber) return -1;

                            const aLayerTitle = a.layer.title.toUpperCase();
                            const bLayerTitle = b.layer.title.toUpperCase();
                            if (aLayerTitle < bLayerTitle) return -1;
                            if (aLayerTitle > bLayerTitle) return 1;

                            if (a.title === '' && b.title === '') {
                                return a.y - b.y;
                            } else if (!a.title) {
                                return -1;
                            } else if (!b.title) {
                                return 1;
                            } else if (Number.isNaN(Number.parseFloat(a.title)) && Number.isNaN(Number.parseFloat(b.title))) {
                                const aTitle = a.title.toUpperCase();
                                const bTitle = b.title.toUpperCase();
                                if (aTitle < bTitle) return -1;
                                if (aTitle > bTitle) return 1;
                                return 0;
                            } else if (!Number.isNaN(Number.parseFloat(a.title)) && !Number.isNaN(Number.parseFloat(b.title))) {
                                return Number.parseFloat(a.title) - Number.parseFloat(b.title);
                            } else if (Number.isNaN(Number.parseFloat(a.title))) {
                                return 1;
                            } else if (Number.isNaN(Number.parseFloat(b.title))) {
                                return -1;
                            }
                        }

                        if (a.pageNumber > b.pageNumber) return -1;
                        if (a.pageNumber < b.pageNumber) return 1;

                        const aLayerTitle = a.layer.title.toUpperCase();
                        const bLayerTitle = b.layer.title.toUpperCase();
                        if (aLayerTitle < bLayerTitle) return 1;
                        if (aLayerTitle > bLayerTitle) return -1;

                        if (a.title === '' && b.title === '') {
                            return b.y - a.y;
                        } else if (!a.title) {
                            return 1;
                        } else if (!b.title) {
                            return -1;
                        } else if (Number.isNaN(Number.parseFloat(a.title)) && Number.isNaN(Number.parseFloat(b.title))) {
                            const aTitle = a.title.toUpperCase();
                            const bTitle = b.title.toUpperCase();
                            if (aTitle < bTitle) return 1;
                            if (aTitle > bTitle) return -1;
                            return 0;
                        } else if (!Number.isNaN(Number.parseFloat(a.title)) && !Number.isNaN(Number.parseFloat(b.title))) {
                            return Number.parseFloat(b.title) - Number.parseFloat(a.title);
                        } else if (Number.isNaN(Number.parseFloat(a.title))) {
                            return -1;
                        } else if (Number.isNaN(Number.parseFloat(b.title))) {
                            return 1;
                        }
                    }
                    if (this.sortBy === 'layer') {
                        if (this.sortAsc) {
                            const aLayerTitle = a.layer.title.toUpperCase();
                            const bLayerTitle = b.layer.title.toUpperCase();
                            if (aLayerTitle < bLayerTitle) return -1;
                            if (aLayerTitle > bLayerTitle) return 1;

                            if (a.title === '' && b.title === '') {
                                return a.y - b.y;
                            } else if (!a.title) {
                                return -1;
                            } else if (!b.title) {
                                return 1;
                            } else if (Number.isNaN(Number.parseFloat(a.title)) && Number.isNaN(Number.parseFloat(b.title))) {
                                const aTitle = a.title.toUpperCase();
                                const bTitle = b.title.toUpperCase();
                                if (aTitle < bTitle) return -1;
                                if (aTitle > bTitle) return 1;
                                return 0;
                            } else if (!Number.isNaN(Number.parseFloat(a.title)) && !Number.isNaN(Number.parseFloat(b.title))) {
                                return Number.parseFloat(a.title) - Number.parseFloat(b.title);
                            } else if (Number.isNaN(Number.parseFloat(a.title))) {
                                return 1;
                            } else if (Number.isNaN(Number.parseFloat(b.title))) {
                                return -1;
                            }
                        }

                        const aLayerTitle = a.layer.title.toUpperCase();
                        const bLayerTitle = b.layer.title.toUpperCase();
                        if (aLayerTitle < bLayerTitle) return 1;
                        if (aLayerTitle > bLayerTitle) return -1;

                        if (a.title === '' && b.title === '') {
                            return b.y - a.y;
                        } else if (!a.title) {
                            return 1;
                        } else if (!b.title) {
                            return -1;
                        } else if (Number.isNaN(Number.parseFloat(a.title)) && Number.isNaN(Number.parseFloat(b.title))) {
                            const aTitle = a.title.toUpperCase();
                            const bTitle = b.title.toUpperCase();
                            if (aTitle < bTitle) return 1;
                            if (aTitle > bTitle) return -1;
                            return 0;
                        } else if (!Number.isNaN(Number.parseFloat(a.title)) && !Number.isNaN(Number.parseFloat(b.title))) {
                            return Number.parseFloat(b.title) - Number.parseFloat(a.title);
                        } else if (Number.isNaN(Number.parseFloat(a.title))) {
                            return -1;
                        } else if (Number.isNaN(Number.parseFloat(b.title))) {
                            return 1;
                        }
                    }
                    if (this.sortBy === 'cue') {
                        if (this.sortAsc) {
                            if (a.title === '' && b.title === '') {
                                return a.y - b.y;
                            } else if (!a.title) {
                                return -1;
                            } else if (!b.title) {
                                return 1;
                            } else if (Number.isNaN(Number.parseFloat(a.title)) && Number.isNaN(Number.parseFloat(b.title))) {
                                const aTitle = a.title.toUpperCase();
                                const bTitle = b.title.toUpperCase();
                                if (aTitle < bTitle) return -1;
                                if (aTitle > bTitle) return 1;
                                return 0;
                            } else if (!Number.isNaN(Number.parseFloat(a.title)) && !Number.isNaN(Number.parseFloat(b.title))) {
                                return Number.parseFloat(a.title) - Number.parseFloat(b.title);
                            } else if (Number.isNaN(Number.parseFloat(a.title))) {
                                return 1;
                            } else if (Number.isNaN(Number.parseFloat(b.title))) {
                                return -1;
                            }
                        }

                        if (a.title === '' && b.title === '') {
                            return b.y - a.y;
                        } else if (!a.title) {
                            return 1;
                        } else if (!b.title) {
                            return -1;
                        } else if (Number.isNaN(Number.parseFloat(a.title)) && Number.isNaN(Number.parseFloat(b.title))) {
                            const aTitle = a.title.toUpperCase();
                            const bTitle = b.title.toUpperCase();
                            if (aTitle < bTitle) return 1;
                            if (aTitle > bTitle) return -1;
                            return 0;
                        } else if (!Number.isNaN(Number.parseFloat(a.title)) && !Number.isNaN(Number.parseFloat(b.title))) {
                            return Number.parseFloat(b.title) - Number.parseFloat(a.title);
                        } else if (Number.isNaN(Number.parseFloat(a.title))) {
                            return -1;
                        } else if (Number.isNaN(Number.parseFloat(b.title))) {
                            return 1;
                        }
                    }
                }
                return a.pageNumber - b.pageNumber;
            });
        }
    },
    methods: {
        changeVisibleListLayer(layerID, val) {
            if (val) {
                this.$store.dispatch('showListLayer', {id: layerID});
            } else {
                this.$store.dispatch('hideListLayer', {id: layerID});
            }
        },
        exportList() {
            // Every field quoted (a note with a comma stays in its column) and old
            // plain-string notes exported as they are (Sun 18 fix, 11 Oct 2026).
            const rows = [];
            for (const cue of this.allCues.filter(Boolean)) {
                if (cue.data && cue.data.workNote) {
                    const page = this.project.pdfPageNumbers[cue.pageNumber - 1];
                    rows.push({
                        page: (page && page.name) || '',
                        layer: cue.layer ? cue.layer.title : '',
                        cue: cue.title,
                        note: openNoteText(cue.data.workNote)
                    });
                }
            }
            const csv = workNotesCsv(rows);

            const now = new Date();
            const hiddenElement = document.createElement('a');
            const csvData = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
            hiddenElement.href = csvData;
            const filename = this.project.title + '_' + [now.getFullYear(), now.getMonth() + 1, now.getDate()].join('-') + '_' + [now.getHours(), now.getMinutes(), now.getSeconds()].join('-') + '.csv';
            hiddenElement.setAttribute('download', filename);
            document.body.appendChild(hiddenElement);
            hiddenElement.click();
        },
        splicePageNumber(item) {
            return item.title.substr((item.id + '').length);
        },
        open() {
        },
        close() {
        },
        closeWorkNoteNav() {
            this.$refs.worknoteSidenav.close();
        },
        gotoCue(cue) {
            this.focusedCueId = cue.id;
            this.focusedCueEditedAt = cue.editedAt;
            NavBus.$emit('goToPage', cue.pageNumber);
        },
        gotoPrevCue() {
            let foundCueIndex = this.groupedByPages.findIndex(item => item.data.id === this.focusedCueId);
            if (foundCueIndex === -1) foundCueIndex = 0;
            const targetIndex = ((foundCueIndex + this.groupedByPages.length) - 1) % this.groupedByPages.length;
            if (this.groupedByPages[targetIndex].type === 'page') {
                const nextIndex = ((targetIndex + this.groupedByPages.length) - 1) % this.groupedByPages.length;
                return this.gotoCue(this.groupedByPages[nextIndex].data);
            }
            return this.gotoCue(this.groupedByPages[targetIndex].data);
        },
        gotoNextCue() {
            const foundCueIndex = this.groupedByPages.findIndex(item => item.data.id === this.focusedCueId);
            const targetIndex = ((foundCueIndex + this.groupedByPages.length) + 1) % this.groupedByPages.length;
            if (this.groupedByPages[targetIndex].type === 'page') {
                const nextIndex = ((targetIndex + this.groupedByPages.length) + 1) % this.groupedByPages.length;
                return this.gotoCue(this.groupedByPages[nextIndex].data);
            }
            return this.gotoCue(this.groupedByPages[targetIndex].data);
        },
        deleteWorkNoteCue(item, e) {
            e.preventDefault();
            e.stopPropagation();
            this.$store.dispatch('deleteCueWorkNote', item.data);
        },
        getUnArchivedItem(item) {
            const unArchivedItem = item.filter(note => note.archived === false);
            return unArchivedItem.length > 0 ? unArchivedItem[0] : null;
        },
        archiveWorkNoteCue(item, e) {
            e.preventDefault();
            e.stopPropagation();
            if (!this.editable(item)) return;
            const newWorkNotes = archiveNote(item.data.workNote, item.editedAt, item.data.editedAt || item.editedAt || Date.now());

            const key = 'data.workNote';
            this.$store.dispatch('modifyCue', {
                id: item.id,
                data: {
                    [key]: newWorkNotes
                }
            });
        },
        unArchiveWorkNoteCue(note, e) {
            e.preventDefault();
            e.stopPropagation();
            if (!this.editable(note.data)) return;
            // The cue's open note is archived, not deleted (Josh, 11 Oct 2026).
            const newWorkNotes = restoreNote(note.data.data.workNote, note.data.editedAt);

            const key = 'data.workNote';
            this.$store.dispatch('modifyCue', {
                id: note.data.id,
                data: {
                    [key]: newWorkNotes
                }
            });
        },
        removeArchivedNote(item, e) {
            e.preventDefault();
            e.stopPropagation();
            // Was `!this.editable`, which tests the method itself and never blocked.
            if (!this.editable(item.data)) return;
            const tempWorkNote = removeNote(item.data.data.workNote, item.data.editedAt);

            const key = 'data.workNote';
            this.$store.dispatch('modifyCue', {
                id: item.data.id,
                data: {
                    [key]: tempWorkNote
                }
            });
        },
        getLayer(cue) {
            return this.layerByCue(cue);
        },
        editable(cue) {
            const layer = this.getLayer(cue);
            if (layer) {
                const filter = this.editableLayers.filter(l => l.id === layer.id);
                return filter.length > 0;
            }
            return false;
        },
        changeViewMode() {
            this.isSwitchedArchive = !this.isSwitchedArchive;
        },
        getEditedDateTime(worknote) {
            const nowSeconds = Date.now();
            let date = new Date(nowSeconds);
            if (worknote.editedAt) {
                date = typeof worknote.editedAt === 'number' ? new Date(worknote.editedAt) : new Date(worknote.editedAt.seconds * 1000);
            }
            let hours = date.getHours();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours %= 12;
            hours = hours > 0 ? hours : 12;
            const minutes = '0' + date.getMinutes();
            const seconds = '0' + date.getSeconds();
            const year = date.getFullYear();
            const month = '0' + (date.getMonth() + 1);
            const day = '0' + date.getDate();
            const formattedTime = month.substr(-2) + '/' + day.substr(-2) + '/' + year + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2) + ' ' + ampm;
            return formattedTime;
        }
    },
    components: {
    },
    created: function() {
        NavBus.$on('worknote-nav.toggle', () => {
            if (this.$refs.worknoteSidenav) {
                this.$refs.worknoteSidenav.toggle();
            }
        });
    },
    beforeDestroy: function() {
        NavBus.$off('worknote-nav.toggle');
    }
};
export default WorkNoteCuesNav;
</script>

<style lang="scss">
.worknote-side-nav {
    .worknote-side-nav-toolbar {
        display: flex;
        justify-content: center;
        .worknote-side-nav-toolbar-labels {
            text-align: center;
            p {
                font-size: 24px;
                font-weight: bold;
                line-height: 1.5;
                margin: 1rem 0 0;
            }
            span {
                display: block;
                font-size: 20px;
                margin-bottom: 8px;
            }
        }
        .btn-close-worknote-sidenav {
            position: absolute;
            right: 4px;
            top: 4px;
            margin: 0;
            transform: scale(0.6);
        }
    }
    .md-sidenav-content {
        top: 64px;
        width: 400px;
        .worknote-side-nav-items-list {
            padding: 0;
            .switch-mode-link {
                display: flex;
                padding: 8px 16px;
                div {
                    padding: 10px;
                    cursor: pointer;
                    span {
                        margin-left:4px;
                        font-size: 16px;
                    }
                }

                .md-button {
                   margin: 0;
                }


            }
        }
        .worknote-item-page {
            background: #ccc;
        }
        .worknote-item-layer {
            .md-list-item-container {
                font-weight: bold !important;
                min-height:30px;
            }
        }
        .worknote-item-cue {
            .worknote-item-cue-info {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                line-height: 1.3;
                padding: 8px 0;
                width: auto;
                max-width: 100%;
                .worknote-item-cue-info-title {
                    font-weight: 600;
                    margin-bottom: 4px;
                    display: block;
                }
                .worknote-item-cue-info-body {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    line-height: 1.3;
                    padding: 0px 0;
                    width: auto;
                    justify-content: space-between;
                    max-width: 100%;
                    width: 100%;
                    .worknote-item-cue-info-date {
                        padding-top: 0px;
                        align-self: flex-end;
                        margin-left: auto;
                    }
                }
                .worknote-item-cue-info-desc {
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: break-spaces;
                }
                
            }
            .btn-archive-cue {
                width: 23px;
                height: 26px;
                min-width: 20px;
                min-height: 20px;
                padding: 0px;
                top: -6px;
            }
            &.selectedCue {
                .md-icon {
                    margin-right: 4px;
                }
                .btn-delete-cue {
                    margin-right: 0;
                }
                .btn-archive-cue {
                    width: 23px;
                    height: 26px;
                    min-width: 20px;
                    min-height: 20px;
                    padding: 0px;
                    top: -6px;
                }
                .worknote-item-cue-info {
                    max-width: 100%;
                }
            }
        }
    }
}


.list-view-visible-layers {
	padding-inline: 16px;
}



    .md-theme-show-mode.md-list {
        .worknote-item-page {
            background: #555;
        }
    }
</style>


// WEBPACK FOOTER //
// nav.vue?795eb3c5